import { forwardRef, type Ref, type SVGProps } from "react";
const IconSearchHeartOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M17.12 11.45A2.24 2.24 0 0 0 14 12s-1.63-1.8-3.13-.55a2.24 2.24 0 0 0-.22 3.34l.19.18 3 3a.28.28 0 0 0 .4 0l3-3 .18-.18a2.19 2.19 0 0 0-.3-3.34"
    />
    <path
      fill="currentColor"
      d="m29.71 28.29-6.55-6.55a12 12 0 1 0-1.41 1.41l6.55 6.55a1 1 0 0 0 1.42 0 1 1 0 0 0-.01-1.41M14 24a10 10 0 1 1 10-10 10 10 0 0 1-10 10"
    />
  </svg>
);
const ForwardRef = forwardRef(IconSearchHeartOutlineSVG);
ForwardRef.displayName = "IconSearchHeartOutline";
export { ForwardRef as IconSearchHeartOutline };
